import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    root: true
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    screen: require('./screen').store
  }
})
